import "aws-amplify/auth/enable-oauth-listener";
import "./styles.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { Toaster } from "@recobra/ui/sonner";

import { DocumentEventsProvider } from "./documents";
import { EnvironmentRibbon, returnAfterSignIn } from "./layout";
import { configureAmplify } from "./lib";
import { LocaleProvider } from "./lib";
import { queryClient } from "./lib";
import { applyTheme, lastAppliedTheme } from "./lib";
import { router } from "./Router";

returnAfterSignIn((href) => void router.navigate({ href, replace: true }));
configureAmplify();
applyTheme(lastAppliedTheme());

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing #root element in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <EnvironmentRibbon />
    <QueryClientProvider client={queryClient}>
      <DocumentEventsProvider>
        <LocaleProvider>
          <RouterProvider router={router} />
        </LocaleProvider>
        <Toaster richColors closeButton position="top-right" />
      </DocumentEventsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
